module.exports = __webpack_public_path__ + "media/einde.36f2a4b5.mp3";